import { Group, Progress, Text } from '@mantine/core';

interface StreamProgressProps {
  /** Whether a stream is currently running (from the SDK streaming hook's `isLoading`). */
  loading: boolean;
  /** Progress percentage 0–100 (from the streaming hook's `progress`). */
  progress: number;
  /** Rows received so far (from the streaming hook's `loadedCount`). */
  loadedCount: number;
  /** Plural noun for the rows being streamed, e.g. "cases", "leaders". */
  label?: string;
}

/**
 * Thin progress strip shown above a list while an SDK batch stream is still filling it.
 *
 * The streaming hooks (`useCaseStreaming`, `useLeaderStreaming`, …) push each batch into `items`
 * as it lands, so the table already has rows on screen while later pages are in flight — this just
 * tells the user more are still coming. Renders nothing once the stream finishes.
 */
export default function StreamProgress({
  loading,
  progress,
  loadedCount,
  label = 'records',
}: StreamProgressProps) {
  if (!loading) return null;

  return (
    <Group gap="sm" align="center" wrap="nowrap" mb="md">
      <Progress value={progress} size="sm" radius="xl" striped animated style={{ flex: 1 }} />
      <Text size="xs" c="dimmed" style={{ whiteSpace: 'nowrap' }}>
        Loaded {loadedCount} {label}…
      </Text>
    </Group>
  );
}
